module.exports = __webpack_public_path__ + "static/Feature-2-7a07740148597178d2eca31c2638f127.svg";